// extracted by mini-css-extract-plugin
module.exports = {"container":"toe0","wide":"x-QP","header":"UajU","body":"sLcw","label":"tAQJ","text":"qcQK","animatedBackground":"hDAB","placeHolderShimmer":"dKze"};